import { render, staticRenderFns } from "./TiposClientesLista.vue?vue&type=template&id=964e1010&scoped=true&"
import script from "./TiposClientesLista.vue?vue&type=script&lang=js&"
export * from "./TiposClientesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964e1010",
  null
  
)

export default component.exports